import { Reducer } from 'redux';
import { Map } from 'immutable';

import { BudgetAllocationActions } from 'entities/budgetAllocation/actions';

import { ADD, ADD_MULTIPLE, REMOVE, UPDATE } from './constants';
import BudgetAllocation from './model';

export type BudgetAllocationMap = Map<string, BudgetAllocation>;

const initialState = Map<string, BudgetAllocation>();

const budgetAllocationReducer: Reducer<BudgetAllocationMap, BudgetAllocationActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ADD:
      return state.set(action.budgetAllocation.id, action.budgetAllocation);

    case ADD_MULTIPLE:
      return state.merge(action.budgetAllocations);

    case UPDATE:
      return state.set(action.budgetAllocation.id, action.budgetAllocation);

    case REMOVE:
      return state.delete(action.id);

    default:
      return state;
  }
};

export default budgetAllocationReducer;
